import { Popover, Tag } from 'antd';
import TruncatedText from '@client/components/ui/TruncatedText';
import { HtmlContent } from '@client/utils/html_content';

const ItemsWithPopover = ({ items, getItemName, maxVisible = 1 }) => {
  if (!items?.length)
    return <span className="text-gray-400 text-xs italic font-light">N/A</span>;

  const uniqueItems = items.filter(
    (item, index, self) => index === self.findIndex((t) => t.id === item.id)
  );

  const visibleItems = uniqueItems.slice(0, maxVisible);
  const hiddenItems = uniqueItems.slice(maxVisible);

  const popoverContent = hiddenItems.length > 0 && (
    <div className="flex flex-col gap-1 max-w-sm">
      {hiddenItems.map((item, index) => (
        <Tag key={index} size="small" className="whitespace-normal break-words">
          <HtmlContent html={getItemName(item)} />
        </Tag>
      ))}
    </div>
  );

  return (
    <div className="flex items-center gap-1">
      <div className="break-words">
        {visibleItems.map((item, index) => (
          <span key={index}>
            <TruncatedText text={getItemName(item)} maxLength={30} />
            {index < visibleItems.length - 1 && ', '}
          </span>
        ))}
      </div>
      {hiddenItems.length > 0 && (
        <Popover
          content={popoverContent}
          title={`${hiddenItems.length} élément${hiddenItems.length > 1 ? 's' : ''} de plus`}
          trigger="hover"
          overlayStyle={{ maxWidth: '400px' }}
          styles={{
            body: { maxWidth: '400px' },
          }}
        >
          <span className="cursor-pointer text-xs px-1 py-0.5 border border-dashed border-gray-400 rounded bg-transparent text-gray-600 hover:border-gray-600 hover:text-gray-800 flex-shrink-0">
            +{hiddenItems.length}
          </span>
        </Popover>
      )}
    </div>
  );
};

export default ItemsWithPopover;
